import TotalProgress from "./TotalProgress";

export default TotalProgress;